import React from "react";
import { Table } from "react-bootstrap";
import DeleteIcon from "@material-ui/icons/Delete";
import scanimg from "../../image/barcodescan.png";

import { camelCase, startCase } from "lodash";
import { useBilling } from "../KOTbillingProvider";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import { useCountry, useCurrency } from "../../../provider/courtryProvider";

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    "& tr:nth-of-type(even) input": {
      backgroundColor: "#F3F3F3 !important",
    },
  },
}));

const BillingTable = () => {
  const {
    state: { addedProducts },
    updateProductPriceFromProduct,
    removeProductFromBilling,
    updateProductQuantityFromProduct,
  } = useBilling();
  const taxMaster = useSelector((state) => state.taxList.taxList);
  const billLineSettings = useSelector((state) => state.settings.settings);
  const classes = useStyles();
  const country = useCountry();
  const currencyFormatter = useCurrency();
  return (
    <div className="product-table" style={{ background: "#feffff" }}>
      <div className="product-table-header" style={{ background: "#feffff" }}>
        <div className="product-table-header-order">
          <p>Order Items ({addedProducts.length})</p>
        </div>
        <div className="product-table-header-line">
          <p>|</p>
        </div>
        <div className="product-table-header-invoice">
          <p>
            Invoice No: {billLineSettings?.invoicePrefixField}
            {billLineSettings?.currentInvoiceNumber}
          </p>
        </div>
      </div>
      {addedProducts.length > 0 ? (
        <Table responsive="md" className={classes.tableStyle}>
          <thead>
            <tr>
              <th
                style={{
                  verticalAlign: "middle",
                  fontWeight: "500",
                }}
              >
                Item
              </th>
              {billLineSettings?.itemMRP && (
                <th
                  style={{
                    verticalAlign: "middle",
                    fontWeight: "500",
                  }}
                >
                  MRP({country.CurrencySymbol})
                </th>
              )}
              <th
                style={{
                  verticalAlign: "middle",
                  fontWeight: "500",
                }}
              >
                Rate({country.CurrencySymbol})
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  fontWeight: "500",
                }}
              >
                Qty.
              </th>
              {/* {billLineSettings.itemWastage && (
              <th
                style={{
                  verticalAlign: "middle",
                  fontWeight: "500",
                }}
              >
                Wast.(%)
              </th>
            )}
            {billLineSettings.itemLabour && (
              <th
                style={{
                  verticalAlign: "middle",
                  fontWeight: "500",
                }}
              >
                Labour(%)
              </th>
            )} */}
              {billLineSettings?.hsnCode && (
                <th
                  style={{
                    verticalAlign: "middle",
                    fontWeight: "500",
                  }}
                >
                  HSN
                </th>
              )}
              {billLineSettings?.itemLevelTax && (
                <>
                  <th
                    style={{
                      verticalAlign: "middle",
                      fontWeight: "500",
                      textAlign: "center",
                    }}
                  >
                    Tax(%)
                  </th>
                  <th
                    style={{
                      verticalAlign: "middle",
                      fontWeight: "500",
                      width: "150px",
                    }}
                  >
                    Inclusive/Exclusive
                  </th>
                </>
              )}
              <th
                style={{
                  verticalAlign: "middle",
                  fontWeight: "500",
                }}
              >
                Subtotal({country.CurrencySymbol})
              </th>
              <th
                style={{
                  verticalAlign: "middle",
                  fontWeight: "500",
                }}
              ></th>
            </tr>
          </thead>
          <tbody>
            {addedProducts.map((data, index) => {
              return (
                <tr
                  key={data.productId}
                  className="align-items-center"
                  style={{
                    background: "#feffff",
                    verticalAlign: "middle",
                  }}
                >
                  <td style={{ verticalAlign: "middle" }}>
                    <div className="productname-input">
                      <p>{data.productName}</p>
                      <h6>{data.unitOfMeasurment}</h6>
                    </div>
                  </td>
                  {billLineSettings?.itemMRP && (
                    <td
                      style={{
                        verticalAlign: "middle",
                        textAlign: "left",
                      }}
                    >
                      <p>
                        {data.productMrp
                          ? parseFloat(data.productMrp).toFixed(2)
                          : "0.00"}
                      </p>
                    </td>
                  )}
                  <td
                    style={{
                      verticalAlign: "middle",
                    }}
                  >
                    <p style={{ textAlign: "left" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderBottom: "0.2px dashed #000000",
                          width: "80px",
                          backgroundColor: "white",
                        }}
                      >
                        <input
                          placeholder="Price"
                          style={{
                            width: "80px",
                          }}
                          value={data.productPrice}
                          type="number"
                          name="productPrice"
                          onWheel={(e) => e.target.blur()}
                          onChange={(e) => {
                            return updateProductPriceFromProduct?.(
                              data,
                              e.target.value
                            );
                          }}
                        />
                      </div>
                      {/* {data.productPrice
                      ? parseFloat(data.productPrice).toFixed(2)
                      : "0.00"} */}
                    </p>
                    {billLineSettings?.itemDiscount && (
                      <p>
                        {data.discountPrice ? (
                          data.discountType ? (
                            data.discountType === "flat" ? (
                              <p className="ratecolor">
                                -{currencyFormatter(data.discountPrice)}
                              </p>
                            ) : (
                              <p className="ratecolor">
                                -{data.discountPrice}%
                              </p>
                            )
                          ) : (
                            <></>
                          )
                        ) : (
                          <></>
                        )}
                      </p>
                    )}
                  </td>
                  <td style={{ verticalAlign: "initial" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        borderBottom: "0.2px dashed #000000",
                        width: "50px",
                        backgroundColor: "white",
                      }}
                    >
                      <input
                        placeholder="Qty"
                        value={data.count}
                        name="count"
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) =>
                          updateProductQuantityFromProduct?.(
                            data,
                            e.target.value
                          )
                        }
                      />
                    </div>
                  </td>
                  {/* {billLineSettings.itemWastage && (
                  <td style={{ verticalAlign: "middle" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        {data.productWastage
                          ? data.productWastage
                          : "0%"}
                      </div>
                    </div>
                  </td>
                )} */}
                  {/* {billLineSettings.itemLabour && (
                  <td style={{ verticalAlign: "middle" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        {data.productLabour
                          ? data.productLabour
                          : "0%"}
                      </div>
                    </div>
                  </td>
                )} */}
                  {billLineSettings?.hsnCode && (
                    <td style={{ verticalAlign: "middle" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          {data.productHsnCode ? (
                            <>{data.productHsnCode}</>
                          ) : (
                            "Nil"
                          )}
                        </div>
                      </div>
                    </td>
                  )}
                  {billLineSettings?.itemLevelTax && (
                    <td
                      style={{
                        verticalAlign: "middle",
                      }}
                    >
                      {data.taxId ? (
                        taxMaster.map((tax) => {
                          return (
                            <span>
                              {tax.taxId === data.taxId &&
                                tax.taxId !== "Select Tax" &&
                                tax.taxName}
                            </span>
                          );
                        })
                      ) : (
                        //   <select
                        //   name="taxId"
                        //   style={{
                        //     fontSize: 15,
                        //     marginRight: 10,
                        //     height: "32px",
                        //     width: "150px",
                        //   }}
                        //   value={data.taxId}
                        //   onChange={(e) =>
                        //     handleBillingInputChange(
                        //       e.target.name,
                        //       e.target.value,
                        //       data,
                        //       index
                        //     )
                        //   }
                        //   disabled={true}
                        // >
                        //   <option value={""}>Select Tax</option>
                        //   {taxList.map((tax) => {
                        //     return (
                        //       <option
                        //         key={tax.taxId}
                        //         value={tax.taxId}
                        //       >
                        //         {tax.taxName}
                        //       </option>
                        //     );
                        //   })}
                        // </select>
                        <span>{data.productTax}</span>
                      )}
                    </td>
                  )}
                  {billLineSettings?.itemLevelTax && (
                    <td style={{ verticalAlign: "middle" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        {data?.taxIncExc !== "Inclusive/Exclusive" &&
                          startCase(camelCase(data?.taxIncExc))}
                        {/* <select
                        name="taxIncExc"
                        style={{
                          fontSize: 15,
                          marginRight: 10,
                          height: "32px",
                          width: "150px",
                        }}
                        value={data.taxIncExc}
                        onChange={(e) =>
                          handleBillingInputChange(
                            e.target.name,
                            e.target.value,
                            data,
                            index
                          )
                        }
                        disabled={true}
                      >
                        <option value={""}>
                          Select Inclusive/Exclusive
                        </option>
                        <option value={"inclusive"}>
                          Inclusive
                        </option>
                        <option value={"exclusive"}>
                          Exclusive
                        </option>
                      </select> */}
                      </div>
                    </td>
                  )}
                  <td style={{ verticalAlign: "middle" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        {data.count
                          ? parseFloat(data.itemTotal).toFixed(2)
                          : "0.00"}
                      </div>
                    </div>
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => removeProductFromBilling?.(data.productId)}
                    >
                      <DeleteIcon />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      ) : (
        <div className="noItemDiv">
          <div className="noItemimg">
            <img src={scanimg} width="50px" height="51px" alt={"scanImg"} />
          </div>
          <p className="noItemText" style={{ marginTop: 0 }}>
            Start billing your items by scanning or add items from inventory
            using search
          </p>
        </div>
      )}
    </div>
  );
};

export default BillingTable;
